// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ThumbDownIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ThumbDown/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 10H5.236a2 2 0 0 0-1.789 2.894l3.5 7A2 2 0 0 0 8.737 21h4.017c.163 0 .326-.02.485-.06L17 20m-7-10V5a2 2 0 0 1 2-2h.095c.5 0 .905.405.905.905 0 .714.211 1.412.608 2.006L17 11v9m-7-10h2m5 10h2a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-2.5"
}));
export default ThumbDownIcon;